<template>
    <rich-marker :marker="marker">
        <div class="user-position-pin">
            <div class="user-position-pin-icon bounce" />
            <div class="user-position-pin-pulse" />
        </div>
    </rich-marker>
</template>

<script>
    import RichMarker from './CustomRichMarker';

    export default {
        components: { RichMarker },
        props: {
            marker: {
                type: Object,
                required: true,
            },
        },
    };
</script>